import manifest from 'appConfig';

import {
  Duplexer,
  TransportError,
  VirtualSocket,
  Channel,
} from '@wix/duplexer-js';

const SOCKETS_SERVER_URL = 'duplexer.wix.com';

const isDev = process.env.NODE_ENV !== 'production';

export interface DuplexerChannel extends Channel {}

export interface DuplexerConnection {
  subscribe: VirtualSocket['subscribe'];
  /** Closes the socket; a later `subscribe` opens a new one. */
  disconnect(): void;
}

const openSocket = (instance: string): VirtualSocket => {
  const duplexer = new Duplexer(SOCKETS_SERVER_URL, {
    instanceUpdater: {
      getInstance: () => instance,
    },
  });

  const connection = duplexer.connect({ appDefId: manifest.appDefinitionId });

  if (isDev) {
    connection.on('@duplexer:connected', () => {
      console.log('@duplexer:connected');
    });
    connection.on('@duplexer:disconnected', (e?: TransportError) => {
      console.log('@duplexer:disconnected', e);
    });
    connection.on('@duplexer:connect_error', (e: TransportError) => {
      console.log('@duplexer:connect_error', e);
    });
  }

  return connection;
};

export const createDuplexerConnection = (
  instance: string,
): DuplexerConnection => {
  let socket: VirtualSocket | null = openSocket(instance);

  const close = () => {
    socket?.disconnect();
    socket = null;
  };

  return {
    subscribe: (channelName, opts) => {
      socket ??= openSocket(instance);
      return socket.subscribe(channelName, opts);
    },
    disconnect: close,
  };
};
